<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bWpaxF/tc-custom/9798886932454.jpg?1705539895620" alt="This image is the cover for the book New York Bestiary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New York Bestiary
      </h1>
      <p class="bookDescription body article font2">
        <p>Roberta Albrecht has discovered an adept way to transform fiction into truth. As in the familiar beast fable, the subjects of her alchemy are a series of animals or animal-like creatures, all of whom lack the experiences essential to transformation. Albrecht invites her readers to join them in the decision-making process when she situates them in a specific alembic, that is, in the widely heterogeneous society of New York City where they suffer and learn to survive.</p><p><br/></p><p>All of her subjects begin or end their lives within the geographical confines of New York’s five boroughs: The Bronx, Brooklyn, Manhattan, Queens, and Staten Island. All are confronted with serious questions: Where can I find a friend? How can I join a group? (Or should I?) Where can I be safe? How can I find happiness? Albrecht’s illustrations focus on details particular to these moments, marking the challenges, failures, and successes of each. Her drawings serve as vignettes that enrich the text, making a complete experience, making the visual and verbal arts converge. Readers of these fables will sometimes ponder and sometimes laugh. Sometimes, it is hoped, they will discover things once thought familiar to be refreshingly new.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roberta Albrecht
      </h2>
      
      <p class="authorDescription body article"><p>Roberta J. Albrecht is a retired professor of English from Concordia College New York. Since retiring, she has become an independent scholar. Heretofore, her published work has been scholarly. (Both of her books were published by academic presses, and both have served as required texts for graduate seminars) This current volume is Albrecht&rsquo;s first foray into a radically different field. Here, she ventures into that long-lived didactic tradition of the beast fable represented by such well-known authors as Aesop, Chaucer, Swift, and Orwell. Having lived in New York City for 23 years, she selects animals and animal-like characters that express the cruelty of city (and sometimes country) life. Her illustrations for these stories reinforce the text in that they express ways, both harsh and gentle, that animals (as people) face disappointment as they try to change their position in society. Hers is a courageous effort to reinvent the genre of beast fable.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52b6d1d2